import Switch from '@mui/material/Switch';
import { FC, useState } from 'react';
import { EditActionType, EditState } from '../Pages/Edit';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { orange } from '@mui/material/colors';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import ColorPicker from './ColorPicker';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import { ListItemButton, ListItemText, } from '@mui/material';
import { ExpandLess, ExpandMore, Folder } from '@mui/icons-material';

type EditControlsProps = {
    dispatch: React.Dispatch<{
        type: EditActionType;
        payload?: any;
    }>;
} & EditState;

const theme = createTheme({
    palette: {
        primary: {
            main: orange[ 500 ],
            light: orange[ 500 ],
            dark: 'white'
        },

        secondary: {
            // This is green.A700 as hex.
            main: '#11cb5f',
        },
        action: {
            // active: 'rgba(0, 0, 0, 0.54)',
            // hover: 'rgba(0, 0, 0, 0.04)',
            // hoverOpacity: 0.04,
            // selected: 'rgba(0, 0, 0, 0.08)',
            // selectedOpacity: 0.08,
            // disabled: 'rgba(0, 0, 0, 0.26)',
            // disabledBackground: 'rgba(0, 0, 0, 0.12)',
            // disabledOpacity: 0.38,
            // focus: 'rgba(0, 0, 0, 0.12)',
            // focusOpacity: 1,
            // activatedOpacity: 1
        }
    },
});

enum foldableRegions {
    NONE = '',
    BASE = 'BASE',
    SESSION = 'SESSION'
}

const EditControls: FC<EditControlsProps> = (props) => {
    const [ openRegion, setRegion ] = useState(foldableRegions.BASE);

    const changeFoldedRegion = (region: foldableRegions) => {
        return () => setRegion(region);
    };

    return (
        <ThemeProvider theme={ theme }>
            <List
                sx={ { width: 230 } }
                component="nav"
                aria-labelledby="nested-list-subheader"
            >
                <FormControl sx={ { width: 230 } } component="fieldset" variant="standard">
                    <ListItemButton onClick={ changeFoldedRegion(openRegion === foldableRegions.BASE ? foldableRegions.NONE : foldableRegions.BASE) } sx={ { bgcolor: '#545a65' } }>
                        <ListItemText primary="Base" />
                        { openRegion === foldableRegions.BASE ? <ExpandLess /> : <ExpandMore /> }
                    </ListItemButton>
                    <Collapse in={ openRegion === foldableRegions.BASE } timeout="auto" unmountOnExit>
                        <FormGroup>
                            <FormControlLabel
                                control={ <Switch checked={ props.showDisplayName } onChange={ () => props.dispatch({ type: EditActionType.ToggleDisplayName }) } /> }
                                label="Show Display Name"
                            />
                            <FormControlLabel
                                control={ <Switch checked={ props.showConnectCode } onChange={ () => props.dispatch({ type: EditActionType.ToggleConnectCode }) } /> }
                                label="Show Connect Code"
                            />
                            <FormControlLabel
                                control={ <Switch checked={ props.showRankIcon } onChange={ () => props.dispatch({ type: EditActionType.ToggleRankIcon }) } /> }
                                label="Show Rank Icon"
                            />
                            <FormControlLabel
                                control={ <Switch checked={ props.showRankName } onChange={ () => props.dispatch({ type: EditActionType.ToggleRankName }) } /> }
                                label="Show Rank Name"
                            />
                            <FormControlLabel
                                control={ <Switch checked={ props.showRankNumber } onChange={ () => props.dispatch({ type: EditActionType.ToggleRankNumber }) } /> }
                                label="Show Rank Number"
                            />
                            <FormControlLabel
                                control={ <Switch checked={ props.showWinLoss } onChange={ () => props.dispatch({ type: EditActionType.ToggleWinLoss }) } /> }
                                label="Show Wins / Losses"
                            />
                            <FormControlLabel
                                control={ <ColorPicker color={ props.backgroundColor } setColor={ (newColor) => props.dispatch({ type: EditActionType.SetBackgroundColor, payload: newColor.rgb }) } /> }
                                label="Choose BG Color"
                            />
                        </FormGroup>
                    </Collapse>
                </FormControl>
            </List>
        </ThemeProvider>
    );
};

export default EditControls;